import script from "./AddNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddNotice.vue?vue&type=script&setup=true&lang=ts"

import "./AddNotice.vue?vue&type=style&index=0&id=3b64e3a0&scope=true&lang=css"

const __exports__ = script;

export default __exports__